import {connect} from 'react-redux';

import {AppContentTypesEnum} from '../../libs/shared/core/src/store/panels/app/commonAppPanelState';
import {AuditTrailPanelId} from '../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../store/appState';
import {replaceParametersAction} from '../store/panels/app/appPanelRouteActions';
import {makeGetAuditTrailParameters} from '../store/panels/audit_trail/auditTrailPanelSelectors';
import {InboxesAuditTrailParameters} from '../store/panels/inboxes/parameters/inboxesParameters';
import {AuditTrail} from './auditTrail';

/*
 * Props.
 */

interface AuditTrailContainerProps {
  panelId: AuditTrailPanelId;
}

/*
 * Redux.
 */

function getPanelId(_state: AppState, props: AuditTrailContainerProps) {
  return props.panelId;
}

const mapStateToProps = makeMapStateToProps<AuditTrailContainerProps>()(() => ({
  parameters: makeGetAuditTrailParameters(getPanelId),
}));

const mapDispatchToProps = makeMapDispatchToProps<AuditTrailContainerProps>()((props) => ({
  onParametersChange: (parameters: InboxesAuditTrailParameters) =>
    replaceParametersAction(props.panelId, {
      contentType: AppContentTypesEnum.AUDIT_TRAIL,
      parameters,
    }),
}));

export const AuditTrailContainer = connect(mapStateToProps, mapDispatchToProps)(AuditTrail);
